import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "CREATE_USER_VIEW", {
  TITLE: "Create user",
  LINK: "Link to share: {{APP_BASE_URL}}/register/{{token}}",
  ERROR: "This email is already registered",
});
